module.exports = {
  showMessageCheckOnce: function() {
    return !window.Android && (
      this.appBridge.version.isApp('webrand') ||
      this.appBridge.version.isApp('pdf') ||
      this.appBridge.version.isGreaterThan('1.2')
    );
  },

  showMessage: function(message, params) {
    message = this.translateFullMessage(message, params);
    this.trigger('show', message);
  },

  messages: [
    { id: 'text-edit', type: 'info' },
    { id: 'pdf-text', type: 'warning' },
    { id: 'share-error', type: 'error' },
    { id: 'upload-error', type: 'error' },
    { id: 'low-resolution', type: 'warning' },
    { id: 'template-back', type: 'info' },
    { id: 'upload-cancel', type: 'info' },
    { id: 'locked-element', type: 'error' },
    { id: 'global-locked', type: 'error' },
    { id: 'share-success', type: 'success' },
    { id: 'convert-to-layout-box', type: 'success' },
    { id: 'thumb-not-load', type: 'warning' },
    { id: 'already-saved', type: 'success' },
    { id: 'nothing-to-save', type: 'success' },
    { id: 'crop', type: 'warning', once: true },
    { id: 'long-time-no-save', type: 'warning' },
    { id: 'locked-layout-image', type: 'warning' },
    { id: 'clipper-rotation-limit', type: 'info' },
    { id: 'uploading-images-save', type: 'warning' },
    { id: 'spacing-and-underline', type: 'warning' },
    { id: 'undo-unlocked-layout-image', type: 'info' },
    { id: 'image-flip-disabled', type: 'warning' },

    { id: 'restriction-text-email', type: 'error' },
    { id: 'restriction-image-content', type: 'error' },
    { id: 'restriction-text-swearing', type: 'error' },
    { id: 'restriction-text-date-range', type: 'error' },
    { id: 'restriction-text-number-nan', type: 'error' },
    { id: 'restriction-text-date-format', type: 'error' },
    { id: 'restriction-text-currency-range', type: 'error' },
    { id: 'restriction-text-currency-format', type: 'error' },
    { id: 'restriction-text-number-out-of-range', type: 'error' },
    { id: 'restriction-text-dictionary-not-found', type: 'error' },
    { id: 'background-color-add', type: 'info' },
    { id: 'resize-text-adjust-to-box', type: 'info', once: true },
    { id: 'processing-pdf', type: 'info' },
    { id: 'pdf-ready', type: 'success' },
    { id: 'generating-table-of-contents', type: 'info' },
    { id: 'table-of-contents-ready', type: 'success' },
    { id: 'video-download-error', type: 'error' },
    { id: 'pdf-download-error', type: 'error' },

    {
      id: 'saved', type: 'success',
      content: function(translate) {
        var now = new Date;
        var H = now.getHours();
        var i = now.getMinutes();

        return translate('advice.content.saved', {
          H : H < 10 ? '0' + H : H,
          i : i < 10 ? '0' + i : i
        });
      }
    }
  ]
};
